import { XIcon } from '@heroicons/react/outline';
import { Modal, Steps } from 'antd';
import React from 'react';

const { Step } = Steps;

interface HowItWorksModalProps {
  isVisible: boolean;
  onClose: () => void;
  onClickVideo?: () => void;
}

const HowItWorksModal: React.FC<HowItWorksModalProps> = ({
  isVisible,
  onClose,
}) => {
  const stepItems = [
    {
      title: 'Step 1',
      description: 'Go to Amazon and find your order',
    },
    {
      title: 'Step 2',
      description: 'Log in or Sign up to our platform',
    },
    {
      title: 'Step 3',
      description: (
        <>
          Copy and paste your order ID here.{' '}
          <a onClick={onClose} className='text-primary underline'>
            Click Here
          </a>
        </>
      ),
    },
    {
      title: 'Step 4',
      description: 'Go to your Library to start reading',
    },
    {
      title: 'Step 5',
      description: 'Or download ZebraLearn app from Playstore or Appstore',
    },
  ];
  return (
    <Modal
      open={isVisible}
      onCancel={onClose}
      footer={null}
      centered
      width={400}
      closeIcon={<XIcon className='text-white w-5 h-5' />}
      className='how-it-works-modal'
      styles={{
        content: {
          backgroundColor: '#121212',
          borderRadius: '16px',
          padding: '32px',
          border: '1px solid rgba(255, 255, 255, 0.1)',
        },
      }}
    >
      <h2 className='text-white text-xl font-semibold mb-8'>How it works?</h2>

      <div className='flex flex-col lg:flex-row gap-6'>
        <div className='flex-1 lg:w-1/2 custom-steps-howItWorks'>
          <Steps
            direction='vertical'
            progressDot
            current={-1}
            className='custom-steps custom-steps-howItWorks'
          >
            {stepItems.map((step, index) => (
              <Step
                key={index}
                title={
                  <div className='flex justify-center items-center pb-0.5 px-2 rounded-full border border-[#3c3b3e] text-grayZl-500 text-xs leading-5'>
                    {step.title}
                  </div>
                }
                description={
                  <div className='text-white text-xs leading-5 mt-2'>
                    {step.description}
                  </div>
                }
              />
            ))}
          </Steps>
        </div>

        {/* <div
          className={clsx(
            !screens.lg && 'h-[1px]',
            'block w-full lg:w-[1px] bg-grayZl-850 ',
          )}
        />

        <div className='flex flex-col lg:w-1/2 items-center justify-center text-center'>
          <div
            onClick={onClickVideo}
            className='w-full h-24 bg-[#FFFFFF1A] rounded-lg flex items-center justify-center cursor-pointer hover:bg-grayZl-850'
          >
            <PlayCircleOutlined className='text-white text-3xl' />
          </div>
          <p className='text-sm text-gray-400 mt-2'>Watch a tutorial video</p>
        </div> */}
      </div>
    </Modal>
  );
};

export default HowItWorksModal;
